import { AppStoreProvider } from './app/app-store';
import { readInitialAppState, UrlStateSync } from './app/UrlStateSync';
import { FeatureInspector } from './features/inspector/FeatureInspector';
import { LayerPanel } from './features/layers/LayerPanel';
import { Legend } from './features/legend/Legend';
import { MapViewport } from './features/map/MapViewport';
import { ElevationProfilePanel } from './features/profile/ElevationProfilePanel';
import { SearchCommand } from './features/search/SearchCommand';

const buildLabel = 'development build';
const healthHref = `${import.meta.env.BASE_URL}health.json`;

export function getBuildStatusText(): string {
  return `Railway3D ${buildLabel}`;
}

export function App() {
  const initialState = readInitialAppState();

  return (
    <AppStoreProvider initialState={initialState}>
      <UrlStateSync />
      <main className="app-shell" aria-labelledby="app-title">
        <section className="map-stage" aria-label="Railway3D map shell">
          <MapViewport />
        </section>
        <section className="app-panel" aria-describedby="app-summary">
          <div className="app-heading">
            <p className="eyebrow">Static-first 3D Railway Geospatial Platform</p>
            <h1 id="app-title">Railway3D</h1>
            <p id="app-summary" className="summary">
              {getBuildStatusText()}. Tokyo Metro pilot: 銀座線 and 丸ノ内線 on a GSI basemap.
              Station locations are approximate public coordinates; rail elevations are illustrative
              only and not surveyed.
            </p>
          </div>
          <SearchCommand />
          <FeatureInspector />
          <ElevationProfilePanel />
          <Legend />
          <LayerPanel />
          <div className="panel-actions">
            <a className="health-link" href={healthHref}>
              View build metadata
            </a>
          </div>
        </section>
      </main>
    </AppStoreProvider>
  );
}
